import state from './moduleSelfieManagementState.js'
import mutations from './moduleSelfieManagementMutations.js'
import actions from './moduleSelfieManagementActions.js'
import getters from './moduleSelfieManagementGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

